import * as urlParse from "url-parse";
import { AuthServerProvider } from "../auth/auth-jwt.service";
import { Client } from "./client.model";
import { environment } from "../../../environments/environment";
import * as i0 from "@angular/core";
import * as i1 from "../auth/auth-jwt.service";
export var TOKEN_PARAMETER = "i3jwt-token";
export var EXIT_PARAMETER = "i3jwt-exit";
var ClientService = /** @class */ (function () {
    function ClientService(authService) {
        this.authService = authService;
        this.clientIdentity = null;
        // Parse client data from location
        var urlParts = this.parse(location.href);
        if (urlParts.query.realm && urlParts.query.redirectUrl) {
            this.clientIdentity = new Client(urlParts.query.redirectUrl, urlParts.query.realm);
            // Forzamos la url de redireccion al telematico
            // } else if (urlParts.hash != "") {
            //   let redirectUrl = this.getParamFromHash(urlParts.hash, "redirectUrl");
            //   let realm = this.getParamFromHash(urlParts.hash, "realm");
            //   this.clientIdentity = new Client(redirectUrl, realm);
        }
        else {
            this.clientIdentity = new Client(environment.appUrl, environment.appRealm);
        }
    }
    ClientService.prototype.getClient = function () {
        return this.clientIdentity;
    };
    ClientService.prototype.setClient = function (c) {
        this.clientIdentity = c;
    };
    ClientService.prototype.redirect = function () {
        var _a;
        // TODO: soportar que la redirectUrl del cliente venga codificada en base64
        var urlParts = this.parse(this.getClient().redirectUrl);
        var token = this.authService.getToken();
        if (token) {
            Object.assign(urlParts.query, (_a = {},
                _a[TOKEN_PARAMETER] = this.authService.getToken(),
                _a));
        }
        window.location.href = urlParts.toString();
    };
    ClientService.prototype.exit = function () {
        var _a;
        // Realiza la redirección pero informando al Client que el usuario ha salido sin realizar autenticación
        var urlParts = this.parse(this.getClient().redirectUrl);
        Object.assign(urlParts.query, (_a = {}, _a[EXIT_PARAMETER] = "1", _a));
        window.location.href = urlParts.toString();
    };
    ClientService.prototype.parse = function (url) {
        var baseUrl = {}; // Ensures that the parsing is independent from the current location of the browser.
        var parseQueryString = true;
        return urlParse(url, baseUrl, parseQueryString);
    };
    ClientService.prototype.getParamFromHash = function (hash, param) {
        var queryStringArray = hash.split("?");
        var queryStringParamArray = queryStringArray[1].split("&");
        var nameValue = null;
        for (var i = 0; i < queryStringParamArray.length; i++) {
            var queryStringNameValueArray = queryStringParamArray[i].split("=");
            if (param == queryStringNameValueArray[0]) {
                nameValue = queryStringNameValueArray[1];
            }
        }
        return nameValue;
    };
    ClientService.ngInjectableDef = i0.defineInjectable({ factory: function ClientService_Factory() { return new ClientService(i0.inject(i1.AuthServerProvider)); }, token: ClientService, providedIn: "root" });
    return ClientService;
}());
export { ClientService };
